/* ASC-CUSTOM (Home v5, 2026-09-06; ticker 2026-09-13): fills the top bar delivery estimate and runs the ticker.
   Date = today + production business days + delivery business days (Mon–Fri only; an order placed on a weekend
   starts counting on Monday). Same arithmetic as the LPO "ships by" line (docs/lpo/shared/design.js shipsBy).
   2026-09-25: delivery days also skip US carrier holidays (window.ASC_NO_DELIVERY, layout/theme.liquid).
   Ticker: the promise items are rendered twice (second copy aria-hidden); when they overflow the bar the track
   gets .is-scrolling and CSS animates it; when they fit, nothing moves. Reduced motion → never scrolls. */
(function () {
  'use strict';
  var bar = document.querySelector('[data-asc-topbar]');
  if (!bar) return;
  var prod = parseInt(bar.getAttribute('data-prod-days'), 10) || 3;
  var ship = parseInt(bar.getAttribute('data-ship-days'), 10) || 4;

  var off = window.ASC_NO_DELIVERY || [];
  function key(d) { return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
  function addBusinessDays(from, days, skipHolidays) {
    var d = new Date(from.getTime());
    d.setHours(12, 0, 0, 0);
    var left = days;
    while (left > 0) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6 && !(skipHolidays && off.indexOf(key(d)) > -1)) left--;
    }
    return d;
  }
  function fmt(d) {
    try { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); }
    catch (e) { return d.toDateString().slice(0, 10); }
  }

  var eta = addBusinessDays(addBusinessDays(new Date(), prod, false), ship, true);
  var outs = bar.querySelectorAll('[data-asc-topbar-text]');
  Array.prototype.forEach.call(outs, function (out) {
    var template = out.getAttribute('data-template') || '';
    if (template.indexOf('{date}') < 0) return;
    var parts = template.split('{date}');
    out.textContent = '';
    out.appendChild(document.createTextNode(parts[0]));
    var b = document.createElement('b');
    b.textContent = fmt(eta);
    b.setAttribute('data-asc-eta', eta.toISOString().slice(0, 10));
    out.appendChild(b);
    if (parts[1]) out.appendChild(document.createTextNode(parts[1]));
  });
  bar.setAttribute('data-asc-topbar-ready', '1');

  /* ticker */
  var wrap = bar.querySelector('[data-asc-topbar-marquee]');
  var track = wrap && wrap.querySelector('.asc-topbar__track');
  var first = track && track.querySelector('.asc-topbar__items');
  if (!wrap || !track || !first) return;
  var reduce = false;
  try { reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  function measure() {
    var need = first.scrollWidth + 24;
    var room = wrap.clientWidth;
    var scrolling = !reduce && need > room;
    track.classList.toggle('is-scrolling', scrolling);
    if (scrolling) track.style.setProperty('--asc-ticker-duration', Math.max(18, Math.round(need / 45)) + 's');
    else track.style.removeProperty('--asc-ticker-duration');
  }
  measure();
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(measure, 150); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure).catch(function () {});
})();
